import CopyComponent from 'components/field/CopyComponent';
import Alert from 'components/global/Alert';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import * as S from '../OTOLink.styled';

const OTOLinkSuccess = ({ link }) => {
	return (
		<S.SuccessContainer>
			<Image
				url="https://storage.googleapis.com/tryoto-public/public/assets/icons/OTO-link/OTO-link-created.svg"
				alt="Success"
				width="16rem"
				height="16rem"
			/>

			<Typography variant="h4" fontWeight="600" align="center">
				otoLinkSuccess
			</Typography>

			<Alert variant="warning" content="otoLinkPaymentAlert" showIcon className="mb-4" />

			<S.LinkContainer>
				<S.Flex justify="space-between" align="center">
					<Typography component="a" href={link} color="var(--content-3)" className="link" noWrap>
						{link}
					</Typography>
					<CopyComponent value={link} share showShareOnly label="shareOTOLink" />
				</S.Flex>
			</S.LinkContainer>
		</S.SuccessContainer>
	);
};

export default OTOLinkSuccess;
